import { render, staticRenderFns } from "./analysis.vue?vue&type=template&id=c879d76e&scoped=true&"
import script from "./analysis.vue?vue&type=script&lang=js&"
export * from "./analysis.vue?vue&type=script&lang=js&"
import style0 from "./analysis.vue?vue&type=style&index=0&id=c879d76e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c879d76e",
  null
  
)

export default component.exports